import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    form_container: {
        marginTop: '2em'
    },
    form_container_padding: {
        // TODO check how can we exclude !important
        padding: `${theme.spacing(2, 20)} !important`,
        [theme.breakpoints.down('sm')]: {
            padding: '0 !important'
        }
    },
    nav_container: {
        justifyContent: 'flex-start',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'center'
        }
    },
    form_button: {
        minWidth: '5em',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        display: 'inline-block'
    },
    swipe: {
        width: 1120,
        marginLeft: -240
    },
    form_button_header: {
        marginBottom: '1em'
    },
    form_align_text: {
        textAlign: 'center'
    },
    form_container_full_width: {
        width: '100% !important'
    },
    form_button_margin_top: {
        marginTop: '1.2em'
    },
    table_paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },
    field_margin_top: {
        marginTop: theme.spacing(4)
    },
    container: {
		padding: theme.spacing(3, 2)
	},
    alignCenter: {
        textAlign: 'center'
    }
}));

export default useStyles;
